import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "block w-full" }
const _hoisted_4 = { class: "flex mb-4" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { class: "text-center" }

import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import GridInputFilter from "@/components/GridInputFilter";
import {Menu, Store} from "@bryntum/grid";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import {$t} from "@/utilities/i18n/config";
import dialog from "@/dialog";
import Error from "@/components/Error";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {ErrorLocationType, PopupType, TableType} from '@/utilities/enums/Enums';
import {useGlobalStore} from "@/stores/GlobalStore";
import {CategoryInfo} from "@/models/category/CategoryInfo";
import {CategoryService} from "@/utilities/services/entities/CategoryService";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage} from "@/AppConfig";
import {PermissionService} from "@/utilities/services/PermissionService";



export default /*#__PURE__*/_defineComponent({
  __name: 'Category',
  setup(__props) {

const gridStore = new Store();
const globalStore = useGlobalStore();
const categoryService = new CategoryService();
const permissionService = new PermissionService();

let selectedCategories = ref<Array<CategoryInfo>>([]);

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};

const deleteSelection = async() => {
  //drop call without selection
  if(!selectedCategories.value?.some(()=>true)) return;

  const answer = await dialog
      .okText($t('global.delete'))
      .cancelText($t('global.cancel'))
      .confirm($t('category.confirmDeletionMulti', {count:selectedCategories.value.length}));

  if (answer) {
    let someEntriesFailed = false;
    for (const category of selectedCategories.value){
      const success = await categoryService.deleteCategory(category.id, ErrorLocationType.table);

      if(!success){
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:category.id}]});
    }

    if (someEntriesFailed) return;

    globalStore.showSuccess($t("global.deleted"));
  }
};

const addOrUpdateCategory = async ()=>{
  const category = globalStore.modal.contentObject as CategoryInfo;

  const updatedCategory = await categoryService.addOrUpdateCategory(category, ErrorLocationType.popup);

  if(updatedCategory === null) return; //TODO additional ID check?
  // fix selection when it was an update -> replace old value in selected-array
  else if(selectedCategories.value.some(el => el.iconName === updatedCategory.iconName)) {
    selectedCategories.value = selectedCategories.value.filter(el => el.iconName !== updatedCategory.iconName);
    selectedCategories.value.push(updatedCategory);
  }

  const categories = await categoryService.getCategories("display", ErrorLocationType.table);

  //@ts-expect-error
  gridStore.setStoreData(categories);

  gridStore.sort(gridStore.sorters);

  globalStore.closeModal();
  globalStore.showSuccess('Gespeichert');
}

const newCategory = async ()=>{
  const category = new CategoryInfo();

  globalStore.openPopup({
    data: category,
    action: addOrUpdateCategory,
    resetButton: false,
    title: $t("popups.categoryEditor.title.new"),
    type: PopupType.categoryEditor
  });
}

const setGridData = async ()=>{
  // start spinner
  globalStore.gridDataIsLoading = true;

  const categories = await categoryService.getCategories("display", ErrorLocationType.table);

  //@ts-expect-error
  gridStore.setStoreData(categories);

  globalStore.reorderColumns(TableType[TableType.category]);

  globalStore.closeModal();
  // stop spinner
  globalStore.gridDataIsLoading = false;
};


const grid = ref(null);
const useGridConfig = {
  headerMenuFeature: false,
  relayStoreEvents: true,
  enableTextSelection: true,
  cellTooltipFeature: {
    hoverDelay: 300,
    textContent: true,
    hideOnDelegateChange: true,
  },
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  height: currentWindowHeight,
  columns : {
    data: [
      {
        id:'title',
        field: 'title',
        text: $t('category.grid.title'),
        flex: 1,
      },
      {
        id:'iconName',
        field: 'iconName',
        text: $t('category.grid.iconName'),
        flex: 1,
        type: 'template',
        template: ({value}:any)=>{
          return `<span class='icon-${value}'></span>`
        }
      },
      {
        id: 'isDefault',
        text: '',
        field: 'isDefault',
        htmlEncode: false,
        sortable: false,
        type: 'template',
        width: 36,
        filterable: false,
        hideable: true,
        tooltipRenderer: ({ record }: any) => {
            if (!record.isDefault) return "";

            return $t('category.grid.isDefault');
        },
        template: ({ record }: any) => {
            if (!record.isDefault) return "";
            return `<div class='gridTooltipButton'><span class='icon-check'></span></div>`;
        },
      },
      {
        id:'menu',
        text	: '',
        width   : 36,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-kontext_horizontal',
          onAction : ({ source: btn }) => {
            const menu = menuFactory(btn.cellInfo.record.data);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.category], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event:any) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedCategories.value = selectedCategories.value.concat(event.selected.map(cr => cr.data))
      selectedCategories.value = selectedCategories.value.filter(c => !event.deselected.map(cr => cr.data).some(cr => c?.iconName === cr?.iconName));
    },
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.originalCount;
    },
  }
};
const gridConfig = reactive(useGridConfig);

const menuFactory = (record:object) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: $t('global.edit'),
        cls: 'color',
        icon: 'icon-editieren',
        hidden: !permissionService.userHasPermission("Category.Edit"),
        weight: 100,
        onItem : ({ menu }) => {
          globalStore.openPopup({
            data:menu.record,
            action:addOrUpdateCategory,
            resetButton:false,
            title:$t("popups.categoryEditor.title.edit"),
            type:PopupType.categoryEditor
          });
        }
      },
      {
        text   : $t('global.delete'),
        hidden: !permissionService.userHasPermission("Category.Delete"),
        cls	: 'color',
        icon: 'icon-loeschen',
        weight : 140,
        onItem: async ({ menu }) => {
          const answer = await dialog
              .okText($t('global.delete'))
              .cancelText($t('global.cancel'))
              .confirm($t('category.confirmDeletionSingle', {name:menu.record.title}));

          if (answer) {
            const success = await categoryService.deleteCategory(menu.record.id, ErrorLocationType.table);

            if (!success) return;

            gridStore.applyChangeset({removed: [{id: menu.record.id}]});

            globalStore.showSuccess($t('category.deleted'));
          }
        }
      }
    ],
  });

  //@ts-expect-error
  menu.setRecord(record);

  return menu;
};


onMounted(async () => {
  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  await setGridData();
})

onBeforeUnmount(()=>{
  window.removeEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});

return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)("category.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_unref(Error), {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              onClick: newCategory,
              title: _unref($t)('category.new')
            }, _hoisted_7, 8, _hoisted_5)), [
              [_directive_permission, 'Category.Create']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              disabled: !_unref(selectedCategories).some(()=>true),
              onClick: deleteSelection,
              title: _unref($t)('global.delete')
            }, _hoisted_10, 8, _hoisted_8)), [
              [_directive_permission, 'Category.Delete']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(GridInputFilter), {
                gridStore: _unref(gridStore),
                hideFilterButton: true
              }, null, 8, ["gridStore"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ], 512), [
        [_vShow, !_unref(globalStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(globalStore).gridDataIsLoading]
      ])
    ])
  ], 64))
}
}

})